import React from "react";

export const FullStar = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37 39" fill="none">
      <path
        d="M18.2349 3.18814L22.9143 13.1671L33.3786 14.7771L25.8068 22.5402L27.5937 33.5075L18.2349 28.3267L8.87609 33.5075L10.663 22.5402L3.09119 14.7771L13.5555 13.1671L18.2349 3.18814Z"
        fill="#FEB312"
      />
    </svg>
  );
};
